export default {
  farms: [],
  farm: undefined,
};
